module.exports = __webpack_public_path__ + "img/contact-row-honda.62adeeed.png";